var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImg12({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5375 3.84668L33.5375 13.8467V33.8467C33.5375 34.7307 33.1863 35.5786 32.5612 36.2037C31.9361 36.8288 31.0882 37.18 30.2042 37.18H10.2042C9.32013 37.18 8.47228 36.8288 7.84716 36.2037C7.22204 35.5786 6.87085 34.7307 6.87085 33.8467V7.18001C6.87085 6.29596 7.22204 5.44811 7.84716 4.82299C8.47228 4.19787 9.32013 3.84668 10.2042 3.84668H23.5375ZM30.2042 33.8467V15.5133H21.8708V7.18001H10.2042V33.8467H30.2042ZM28.5375 22.18V32.18H11.8708L20.2042 23.8467L23.5375 27.18M16.8708 18.0133C16.8708 18.6764 16.6075 19.3123 16.1386 19.7811C15.6698 20.25 15.0339 20.5133 14.3708 20.5133C13.7078 20.5133 13.0719 20.25 12.6031 19.7811C12.1342 19.3123 11.8708 18.6764 11.8708 18.0133C11.8708 17.3503 12.1342 16.7144 12.6031 16.2456C13.0719 15.7767 13.7078 15.5133 14.3708 15.5133C15.0339 15.5133 15.6698 15.7767 16.1386 16.2456C16.6075 16.7144 16.8708 17.3503 16.8708 18.0133Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImg12);
export default __webpack_public_path__ + "static/media/fileImg12.39ab6f0c1c10b32becf37fc80ab3f4ec.svg";
export { ForwardRef as ReactComponent };